import React, { useId } from "react";
import Box from "@mui/material/Box";
import CustomRadio from "./CustomRadio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import { UserChoice } from "../model/final_balance/user_choice";
import AccessibleFormControlLabel from "../containers/User/components/AccessibleFormControlLabel";

interface IProps {
  question: string;
  radioOptions: UserChoice[];
  handleChangeRadio: any;
  radioValue: string | Number;
}

/*const useStyles = makeStyles({
  radioGrplabel: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 16,
    lineHeight: "140%",
    color: "#383D39",
  },
});*/

export default function RadioQuestions({
  question,
  radioOptions,
  handleChangeRadio,
  radioValue,
}: IProps) {
  const groupId = `radio-group${useId()}`;
  return (
    <Box>
      {question && <FormLabel className={'radio-group-label'} htmlFor={groupId}>{question}</FormLabel>}
      <RadioGroup id={groupId} value={radioValue} onChange={handleChangeRadio}>
        {radioOptions.map((option: UserChoice, index: any) => {
          return (
            <FormControlLabel
              key={index}
              value={option.id}
              control={<CustomRadio />}
              label={option.label}
              disabled={option.disabled}
              className="radio-group-row-sm"
            />
          );
        })}
      </RadioGroup>
    </Box>
  );
}
